import axios from 'axios'
import qs from 'qs'
import {apiUrl, apiWeb} from '@/config/net'

class ActiveModel {
  constructor () {
    this.formItem = {
      storeName: null,
      telephoneNum: null,
      verifyCodeNum: null,
      paymentCode: '',
      newName: '',
      originName: '',
      url: `${apiUrl}/api/wechat.ashx`,
      codeWorking: false,
      codeTimeout: 60,
      timeSecond: '',
      timer: null
    }
  }

  _urlMaker (data) {
    let query = qs.stringify(data)
    return `${this.formItem.url}?${query}`
  }

  getOrginStoreName () {
    return axios.get(`${apiWeb}/account/account_name?phoneNumber=${this.formItem.telephoneNum}`).then(res => {
      let data = res.data.data || ''
      return data
    })
  }

  getVerifyCode () {
    return axios.post(`${apiWeb}/account/sms_send_authcode?phoneNumber=${this.formItem.telephoneNum}`).then(res => {
      let data = res.data.code
      return data
    }).catch(e => {
    })
  }

  checkVertifyCode () {
    let formData = {
      PhoneNumber: this.formItem.telephoneNum,
      AuthCode: this.formItem.verifyCodeNum
    }
    return axios.post(`${apiWeb}/account/sms_check_authcode`, formData).then(res => {
      let data = res.data.data
      return data
    }).catch(e => {
    })
  }

  // 检测是否已注册
  haveSignup () {
    let url = this._urlMaker({
      type: 'checkphone',
      phone: this.formItem.telephoneNum
    })
    console.log('_urlMaker', url)
    return axios.get(url).then(res => {
      let data = res.data
      return data
    }).catch(e => {
    })
  }

  // 获取扫码收款审核通过状态
  getStatus () {
    return axios.get(`${apiWeb}/cebcollection/mobilepay-status?phoneNumber=${this.formItem.telephoneNum}`).then(res => {
      let data = res.data.data
      return data
    })
  }

  // 验证手机号是否注册
  verifyRegister () {
    return axios.get(`${apiWeb}/account/account_check_phone?phoneNumber=${this.formItem.telephoneNum}`).then(res => {
      let data = res.data.data
      return data
    }).catch(e => {
    })
  }

  fireTimer () {
    if (this.formItem.timer) clearTimeout(this.formItem.timer)
    this.formItem.codeWorking = true
    let now = 0
    let timerProc = () => {
      now += 1
      if (now < this.formItem.codeTimeout) {
        this.formItem.timeSecond = `${this.formItem.codeTimeout - now} s`
        this.formItem.timer = setTimeout(timerProc, 1000)
      } else {
        this.formItem.codeWorking = false
      }
    }
    timerProc()
  }

  activePayment () {
    let formData = {
      PhoneNumber: this.formItem.telephoneNum,
      AuthCode: this.formItem.verifyCodeNum,
      PaymentCode: this.formItem.paymentCode,
      AccountOriginName: this.formItem.originName,
      AccountNewName: this.formItem.newName
    }
    return axios.post(`${apiWeb}/paymentcode/activate`, formData).then(res => {
      // 1代表保存成功
      return res || {}
    }, e => {
      console.log(e)
      return Promise.reject(e)
    })
  }
}

export default ActiveModel



// WEBPACK FOOTER //
// ./src/model/active-payment/index.js